import React, { useEffect, useRef, useState } from "react";
import axios, { AxiosResponse } from "axios";
import { DataTableWithoutButtons } from "components/DataTable/DataTableWithoutButtons";
import { AfDataType, GenericColumnData } from "utils/TableColumnData";
import handleWheel from "utils/handleOnWheel";
import { CreateCommanWay, ListCommanWay, PostFormData, UpdateCommanWay } from "API/commonApi";
import { UseMutateFunction, useMutation, useQuery } from "@tanstack/react-query";
import { Img } from "components";
import moment from "moment";
import Swal from "sweetalert2";
import UseToast from "utils/AfToast";
import Select from "react-select";
import { object } from "yup";
import { useFormik } from "formik";
import { Link, useNavigate } from "react-router-dom";
import { utils, write, writeFile } from "xlsx";
import { saveAs } from "file-saver";
import { ArrowDownIcon, ArrowsUpDownIcon, ArrowUpIcon } from "@heroicons/react/24/outline";
import Modal from "components/Modal/Modal";
import { roles } from "utils/constant";
import { AfDateRangePicker } from "components/Input/AfDateRangePicker";
import { Button, Input } from "@heroui/react";
import { useAuthStore } from "store/auth";

const SalaryList: React.FC<any> = (props) => {
  const ADT = AfDataType;
  const navigator = useNavigate();
  const [tableData, setTableData] = useState<any>([]);
  const [totals, setTotals] = useState<any>({});
  const [kpsTotal, setKpsTotal] = useState<any>({});
  const [startDate, setStartDate] = useState<any>(moment().startOf("day").startOf("month").format("YYYY-MM-DD"));
  const [endDate, setEndDate] = useState<any>(moment().endOf("day").endOf("month").format("YYYY-MM-DD"));
  const [sortStat, setSortStat] = useState<any>({});
  const [addModalOpen, setAddModalOpen] = useState(false);
  const [ackNoFilter, setAckNoFilter] = useState("");

  const [query, setQuery] = useState<any>({
    salary_month: {
      $gte: startDate ? startDate : moment().startOf("day").subtract(1, "days"),
      $lte: endDate ? moment(endDate).endOf("day") : moment().endOf("day"),
    },
  });
  const [isDataAdded, setIsDataAdded] = useState(false);
  const [branchOpt, setBranchOtp] = useState<any>();
  const [branchOptions, setBranchOptions] = useState<any>([{ value: 0, label: "Loading..." }]);
  const [cityOptions, setCityOptions] = useState<any>([{ value: 0, label: "Loading..." }]);
  const [selectedCity, setSelectedCity] = useState<any>();

  const [selectedStatus, setSelectedStatus] = useState<any>();

  const [verifyModalOpen, setVerifyModalOpen] = useState(false);

  const [seletedPayment, setSeletedPayment] = useState<any>({});
  const [disburseModalOpen, setDisburseModalOpen] = useState(false);
  const [rejectModalOpen, setRejectModalOpen] = useState(false);
  const [remark, setRemark] = useState("");

  const [refNo, setRefNo] = useState<any>("");
  const [payDate, setpayDate] = useState<any>("");
  const [payType, setPayType] = useState<any>({});

  // Multi-select state for bulk payment
  const [selectedRows, setSelectedRows] = useState<Set<number>>(new Set());
  const [userMap, setUserMap] = useState<any>({});
  const csvFileRef = useRef<HTMLInputElement>(null);
  const [isUploading, setIsUploading] = useState(false);

  const handleCsvUpload = async () => {
    const file = csvFileRef.current?.files?.[0];
    if (!file) {
      UseToast("Please select a CSV file", "error");
      return;
    }
    if (!file.name.endsWith(".csv")) {
      UseToast("Only CSV files are allowed", "error");
      return;
    }
    setIsUploading(true);
    try {
      const formData = new FormData();
      formData.append("file", file);
      const response: any = await PostFormData("/admin/salary/upload-csv", formData);
      if (response.status === "SUCCESS") {
        UseToast(response.message || "CSV uploaded successfully", "success");
        if (csvFileRef.current) csvFileRef.current.value = "";
        refetch();
      } else {
        UseToast(response.message || "Upload failed", "error");
      }
    } catch (err: any) {
      UseToast(err?.message || "Upload failed", "error");
    } finally {
      setIsUploading(false);
    }
  };

  useQuery(["EmployeeListApi"], () => ListCommanWay("/admin/user/list", { isThirdParty: false }, { paginate: 1000 }), {
    keepPreviousData: true,
    onSuccess(data) {
      if (data.status == "SUCCESS") {
        let opt = [];
        let uMap = {};
        data.data.data.forEach((p) => {
          opt.push({
            value: p.id,
            label: p.name,
          });
          uMap[p.id] = p;
        });
        setBranchOptions(opt);
        setUserMap(uMap);
      }
    },
  });

  //7.9 - 6.1 ----- - 2.3: 7th:3:13 - 8: 12:03
  //2.3 - 6.6:

  const {
    mutate: loadAttendanceReport,
    isLoading: isReportLoading,
  }: {
    mutate: UseMutateFunction<AxiosResponse<any, any>, unknown, any, unknown>;
    isLoading: any;
  } = useMutation(
    (id) =>
      ListCommanWay(
        "/admin/attendence/report",
        {
          createdAt: {
            $gte: moment(query?.salary_month?.["$gte"]).startOf("day"),
            $lte: moment(query?.salary_month?.["$lte"]).endOf("day"),
          },
        },
        {}
      ),
    {
      onSuccess: (data: any) => {
        if (data.status == "SUCCESS") {
          const report = data.data?.report;
          if (!report || report.length === 0) {
            UseToast("No data to download", "error");
            return;
          }

          const headers = ["User ID", "Employee Name", "Month", "Year", "Total Days", "Holidays", "Attended Days", "Leave Days", "Business Days", "Holiday Days Worked", "Total Hours", "Missing OUT Days", "Holiday Hours", "Business Hours", "Avg Business Hours", "Missed Hours", "Micro Days", "Base Salary", "Salary Pay"];
          const csvRows = report.filter((r: any) => {
            let basePay = 0;
            try {
              const user = userMap[r.userId];
              const salaryData = typeof user?.salaryData === "string" ? JSON.parse(user.salaryData) : user?.salaryData;
              basePay = Number(salaryData?.basePay) || 0;
            } catch (e) {
              basePay = 0;
            }
            return basePay > 0;
          }).map((r: any) => {
            let basePay = "";
            try {
              const user = userMap[r.userId];
              const salaryData = typeof user?.salaryData === "string" ? JSON.parse(user.salaryData) : user?.salaryData;
              basePay = salaryData?.basePay ?? "";
            } catch (e) {
              basePay = "";
            }
            return [
              r.userId,
              r.userName,
              moment(startDate).format("MM"),
              moment(startDate).format("YYYY"),
              r.totalDays,
              r.totalHoliday,
              r.attendedDays,
              r.leaveDays,
              r.attendedBusinessDays,
              r.attendedHoliDays,
              r.totalHours,
              r.totalMissingOUTDays,
              r.totalHolidayHours,
              r.totalBusinessHours,
              r.attendedBusinessDays ? (Number(r.totalBusinessHours) / Number(r.attendedBusinessDays)).toFixed(2) : "0",
              r.totalMissedHours,
              r.totalMicroDays,
              basePay,
              "",
            ].map(v => `"${String(v ?? "").replace(/"/g, '""')}"`).join(",");
          });

          const csvContent = [headers.join(","), ...csvRows].join("\n");
          const blob = new Blob(["\uFEFF" + csvContent], { type: "text/csv;charset=utf-8;" });
          saveAs(blob, `Attendance_Report_${moment(startDate).format("YYYY-MM")}.csv`);
          UseToast("CSV downloaded successfully", "success");
        } else {
          UseToast(data.message, "error");
        }
      },
      onError: (data: any) => {
        typeof data === "string" ? UseToast(data, "error") : UseToast(data.message, "error");
      },
    }
  );

  useQuery(["CityListApi"], () => ListCommanWay("/admin/city/list", {}, { paginate: 100000 }), {
    onSuccess(data) {
      if (data.status == "SUCCESS") {
        let opt = [];
        if (data?.data) {
          Object.values(data?.data?.data)?.forEach((d: any) => {
            opt.push({
              value: d?.id,
              label: d?.city_name,
            });
          });
          setCityOptions(opt);
        }
      }
    },
  });

  const {
    mutate: deleteSalary,
    isLoading: isDeleting,
  }: {
    mutate: UseMutateFunction<AxiosResponse<any, any>, unknown, any, unknown>;
    isLoading: any;
  } = useMutation((id) => CreateCommanWay({ url: "/admin/salary/deleteMany", data: { isWarning: true, ids: [id] } }), {
    onSuccess: (data: any) => {
      if (data.status == "SUCCESS") {
        setTotals({ grand: 0 });
        UseToast("Payment Removed Successfully", "success");
        refetch();
      } else {
        UseToast(data.message, "error");
      }
    },
    onError: (data: any) => {
      typeof data === "string" ? UseToast(data, "error") : UseToast(data.message, "error");
    },
  });

  const {
    mutate: updatePayMutate,
    isLoading: isloading,
  }: {
    mutate: UseMutateFunction<AxiosResponse<any, any>, unknown, any, unknown>;
    isLoading: any;
  } = useMutation(UpdateCommanWay, {
    onSuccess: (data: any) => {
      if (data.status == "SUCCESS") {
        UseToast("Data Updated Successfully", "success");
        setTotals({ grand: 0 });
        refetch();
        setDisburseModalOpen(false);
        setVerifyModalOpen(false);
        setRejectModalOpen(false);
      } else {
        UseToast(data.message, "error");
      }
    },
    onError: (data: any) => {
      typeof data === "string" ? UseToast(data, "error") : UseToast(data.message, "error");
    },
  });

  const { isFetching, isLoading, refetch } = useQuery(
    ["admin_salarys_report_list"],
    () => ListCommanWay("/admin/salary/list", { ...query }, { paginate: 1000, include: ["_employee"] }),
    {
      keepPreviousData: true,
      onSuccess(data) {
        if (data.status == "SUCCESS") {
          console.log("data.data", data.data);
          setTableData(data.data.data);
          setSortStat({});

          let ary = [...data.data.data];
          let ttt = {
            base: 0,
            cgst: 0,
            sgst: 0,
            igst: 0,
            utgst: 0,
            grand: 0,
            tds: 0,
            paid: 0,
          };

          let kps = {};
          ary.forEach((a) => {
            //console.log(a.base_value);
            ttt.base += Number(a.net_salary || 0);
            ttt.grand += Number(a.net_salary) || 0;
            ttt.tds += Number(a.tds) || 0;
            ttt.paid += (Number(a.net_salary) || 0) - (Number(a.tds) || 0);

            if (!kps[a.payStatus]) {
              kps[a.payStatus] = [0, 0, 0];
            }
            kps[a.payStatus][0]++;
            kps[a.payStatus][1] += Number(a.net_salary) || 0;
            kps[a.payStatus][2] += Number(a.tds) || 0;
          });
          setTotals(ttt);
          setKpsTotal(kps);
        } else {
          setTableData([]);
          setKpsTotal({});
        }
      },
      onError: (data) => {
        setTableData([]);
        setKpsTotal({});
      },
    }
  );

  useEffect(() => {
    setTotals({ grand: 0 });
    refetch();
  }, [query]);

  const __handleSubmit = async () => {
    setIsDataAdded(!isDataAdded);
    console.log(selectedStatus);
    setQuery({
      ...(ackNoFilter
        ? {} // Exclude salary_month if billNo or ackNo is present
        : {
            salary_month: {
              $gte: startDate ? startDate : moment().startOf("day").subtract(1, "days"),
              $lte: endDate ? moment(endDate).endOf("day") : moment().endOf("day"),
            },
          }),
      employee: branchOpt?.value,
      id: ackNoFilter ? ackNoFilter : undefined,
      city: selectedCity?.value,
      payStatus: selectedStatus?.value || undefined,
    });
  };

  const BASE_URL = process.env.REACT_APP_BACKEND_URL;
  const userD = (() => { const auth = localStorage.getItem("auth"); return auth ? JSON.parse(auth) : {}; })();
  const [userDetails, setUserDetails] = useState<any>(userD?.state?.user || {});
  const { paymentPublicKey } = useAuthStore();
  const tableRef = useRef(null);

  // Handle select all
  const handleSelectAll = (checked: boolean) => {
    if (checked) {
      const allIds = tableData.map((row: any) => row.id);
      setSelectedRows(new Set(allIds));
    } else {
      setSelectedRows(new Set());
    }
  };

  // Handle single row select
  const handleRowSelect = (id: number, checked: boolean) => {
    const newSelected = new Set(selectedRows);
    if (checked) {
      newSelected.add(id);
    } else {
      newSelected.delete(id);
    }
    setSelectedRows(newSelected);
  };

  const encryptWithRSA = async (data: object): Promise<string | false> => {
    if (!paymentPublicKey) return false;
    try {
      let pemBody = paymentPublicKey
        .replace(/-----BEGIN (RSA )?PUBLIC KEY-----/g, "")
        .replace(/-----END (RSA )?PUBLIC KEY-----/g, "")
        .replace(/\\n/g, "")
        .replace(/\s/g, "");

      const binaryDer = Uint8Array.from(atob(pemBody), (c) => c.charCodeAt(0));

      const cryptoKey = await crypto.subtle.importKey(
        "spki",
        binaryDer.buffer,
        { name: "RSA-OAEP", hash: "SHA-256" },
        false,
        ["encrypt"],
      );

      const encoded = new TextEncoder().encode(JSON.stringify(data));
      const encrypted = await crypto.subtle.encrypt({ name: "RSA-OAEP" }, cryptoKey, encoded);

      const bytes = new Uint8Array(encrypted);
      let binary = "";
      for (let i = 0; i < bytes.length; i++) {
        binary += String.fromCharCode(bytes[i]);
      }
      return btoa(binary);
    } catch (e) {
      console.error("RSA-OAEP encryption failed:", e);
      return false;
    }
  };

  const handleBulkPayment = async () => {
    if (!paymentPublicKey) {
      UseToast("Payment key not available. Please re-login.", "error");
      return;
    }
    if (selectedRows.size === 0) {
      UseToast("Please select at least one row.", "error");
      return;
    }

    const selectedData = tableData.filter((row: any) => selectedRows.has(row.id));

    // Build HTML for editable amounts table
    let tableHtml = '<div style="max-height:300px;overflow-y:auto;"><table style="width:100%;border-collapse:collapse;font-size:13px;">';
    tableHtml += '<tr style="background:#f3f4f6;"><th style="padding:6px;border:1px solid #e5e7eb;">Employee</th><th style="padding:6px;border:1px solid #e5e7eb;">Payable</th><th style="padding:6px;border:1px solid #e5e7eb;">Pay Amount</th></tr>';
    selectedData.forEach((r: any) => {
      const payable = ((Number(r.net_salary) || 0) - (Number(r.tds) || 0)).toFixed(2);
      tableHtml += `<tr><td style="padding:4px 6px;border:1px solid #e5e7eb;">${r._employee?.name || '-'}</td><td style="padding:4px 6px;border:1px solid #e5e7eb;text-align:right;">₹${payable}</td><td style="padding:4px 6px;border:1px solid #e5e7eb;"><input type="number" id="amt_${r.id}" value="${payable}" max="${payable}" min="0" step="0.01" style="width:100px;padding:4px;border:1px solid #d1d5db;border-radius:4px;text-align:right;" /></td></tr>`;
    });
    tableHtml += '</table></div>';

    const { isConfirmed } = await Swal.fire({
      title: "Salary Bulk Payment",
      html: tableHtml,
      width: 550,
      showCancelButton: true,
      confirmButtonText: "Request OTP",
      preConfirm: () => {
        // Validate amounts
        for (const r of selectedData) {
          const maxPayable = (Number(r.net_salary) || 0) - (Number(r.tds) || 0);
          const input = document.getElementById(`amt_${r.id}`) as HTMLInputElement;
          const amt = Number(input?.value);
          if (isNaN(amt) || amt <= 0) {
            Swal.showValidationMessage(`Invalid amount for ${r._employee?.name}`);
            return false;
          }
          if (amt > maxPayable) {
            Swal.showValidationMessage(`Amount for ${r._employee?.name} cannot exceed ₹${maxPayable.toFixed(2)}`);
            return false;
          }
        }
        return true;
      },
    });

    if (!isConfirmed) return;

    // Collect values after confirm
    const ids: number[] = [];
    const amounts: Record<string, number> = {};
    selectedData.forEach((r: any) => {
      const input = document.getElementById(`amt_${r.id}`) as HTMLInputElement;
      ids.push(r.id);
      amounts[String(r.id)] = Number(input?.value);
    });

    // Encrypt paymentType (backend will self-identify branch for salary)
    const encryptedPayload = await encryptWithRSA({ paymentType: "SALARY" });
    if (!encryptedPayload) {
      UseToast("Encryption failed. Please re-login.", "error");
      return;
    }

    try {
      const otpRes: any = await CreateCommanWay({
        url: "/admin/payment/request-otp",
        data: { ids, amounts, encryptedPayload },
      });

      if (otpRes?.status !== "SUCCESS") {
        UseToast(otpRes?.message || "Failed to request OTP", "error");
        return;
      }

      const requestId = otpRes?.data?.requestId;

      // Ask for OTP
      const { value: otp } = await Swal.fire({
        title: "Enter OTP",
        input: "text",
        inputPlaceholder: "Enter 6-digit OTP",
        showCancelButton: true,
        confirmButtonText: "Release Payment",
        inputValidator: (value) => {
          if (!value) return "Please enter OTP";
          if (value.length !== 6) return "OTP must be 6 digits";
        },
      });

      if (!otp) return;

      // Encrypt OTP payload and call release
      const encryptedRelease = await encryptWithRSA({ requestId, otp });
      if (!encryptedRelease) {
        UseToast("Encryption failed.", "error");
        return;
      }

      const releaseRes: any = await CreateCommanWay({
        url: "/admin/payment/release",
        data: { payload: encryptedRelease },
      });

      if (releaseRes?.status === "SUCCESS") {
        UseToast("Salary payment released successfully!", "success");
        setSelectedRows(new Set());
        refetch();
      } else {
        UseToast(releaseRes?.message || "Payment release failed", "error");
      }
    } catch (err: any) {
      UseToast(typeof err === "string" ? err : err?.message || "Something went wrong", "error");
    }
  };

  const exportToExcel = () => {
    const table = tableRef.current;

    const tableClone = table.cloneNode(true);

    const tfoot = tableClone.getElementsByTagName("tfoot");
    if (tfoot.length > 0) {
      tfoot[0].remove();
    }
    const toIgnore = tableClone.querySelectorAll(".ignore-excel");
    if (toIgnore.length > 0) {
      toIgnore[0].remove();
    }

    const rows = tableClone.querySelectorAll("tbody tr");
    rows.forEach((row) => {
      const dateCell = row.cells[1]; // Second column is at index 1
      dateCell.innerText = moment(dateCell.innerText, "DD/MM/YYYY").format("YYYY-MM-DD");
    });

    console.log(tableClone);

    const ws = utils.table_to_sheet(tableClone);
    const wb = utils.book_new();
    utils.book_append_sheet(wb, ws, "Sheet1");

    Object.keys(ws).forEach((key) => {
      if (key.startsWith("!")) return;

      let cell = ws[key];
      if (cell && cell.h && typeof cell.h === "string") {
        cell.h = null;
      }
      if (cell && cell.l) {
        delete cell.l;
      }
    });

    const wbout = write(wb, { bookType: "xlsx", type: "array" });

    const blob = new Blob([wbout], { type: "application/octet-stream" });
    saveAs(blob, "Salary Report.xlsx");
  };

  const GET_SORT_ICON = (key, info) => {
    switch (sortStat[key]) {
      case "asc":
        return (
          <ArrowDownIcon
            className="h-4 inline-block"
            onClick={() => {
              handleSort(key, info);
            }}
          />
        );
      case "desc":
        return (
          <ArrowUpIcon
            className="h-4 inline-block"
            onClick={() => {
              handleSort(key, info);
            }}
          />
        );
      default:
        return (
          <ArrowsUpDownIcon
            className="h-4 inline-block"
            onClick={() => {
              handleSort(key, info);
            }}
          />
        );
    }
  };

  const handleSort = (key, info) => {
    let data = [...tableData];
    let order = sortStat[key] == "asc" ? "desc" : "asc";

    if (key == "_invoice_no_c_b.isFullPaid") {
      data = data.sort((a, b) => {
        if (order == "asc") {
          return -a["isActive"] + b["isActive"];
        } else {
          return -b["isActive"] + a["isActive"];
        }
      });
    }

    let sortedData = data.sort((a, b) => {
      // Extract the value using the keyPath (e.g., "invoice_data.idpaid")
      const valueA = key.split(".").reduce((obj, key) => obj[key], a);
      const valueB = key.split(".").reduce((obj, key) => obj[key], b);
      // Handle sorting for different data types
      if (valueA < valueB) return order === "asc" ? -1 : 1;
      if (valueA > valueB) return order === "asc" ? 1 : -1;
      return 0; // If equal
    });
    let _sortStat = { ...sortStat };
    _sortStat[key] = order;
    setSortStat(_sortStat);
    setTableData(sortedData);
  };

  return (
    <>
      {rejectModalOpen && (
        <div className="fixed inset-0 overflow-y-auto z-50 bg-black-900/50">
          <div className="flex items-center justify-center min-h-screen">
            <div className="fixed inset-0 bg-black opacity-50"></div>
            <div className="z-50 flex flex-col bg-white p-6 rounded-lg shadow-2xl border-2 border-dark1">
              <div className="">
                <label className="block mb-0.5 text-sm font-medium text-gray-900">Reject Remark</label>
                <input
                  type="text"
                  className={`bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-52 p-2.5`}
                  placeholder="Remark"
                  value={remark}
                  onChange={(e) => setRemark(e.target.value)}
                />
              </div>
              <div className="flex justify-center items-center gap-x-4">
                <button
                  className="mt-4 self-center rounded-md px-4 py-2 text-sm font-medium text-white bg-red-500 border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700"
                  onClick={() => {
                    updatePayMutate({
                      url: "/admin/salary/update/" + seletedPayment?.id,
                      data: {
                        status: "REJECTED",
                        remark: remark,
                      },
                    });
                  }}
                >
                  Reject
                </button>
                <button
                  className="mt-4 self-center rounded-md px-4 py-2 text-sm font-medium text-white bg-green-500 border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700"
                  onClick={() => {
                    setRejectModalOpen(false);
                  }}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {disburseModalOpen && (
        <div className="fixed inset-0 overflow-y-auto z-50 bg-black-900/50">
          <div className="flex items-center justify-center min-h-full">
            <div className="fixed inset-0 bg-black opacity-50"></div>
            <div className="z-50 flex flex-col gap-4 bg-white p-6 rounded-lg shadow-2xl border-2 border-dark1 w-full max-w-sm">
              <div className="">
                <label className="block mb-0.5 text-sm font-medium text-gray-900">
                  Payment Date: {seletedPayment.payDate ? moment(seletedPayment.payDate, "DD-MM-YYYY HH:mm:ss").format("DD-MM-YYYY") : "-"}
                </label>
                {/*<input
                  type="date"
                  className={`bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5`}
                  value={payDate}
                  onChange={(e) => setpayDate(e.target.value)}
                  disabled={true}
                />*/}
              </div>

              <div className={`items-center gap-2`}>
                <label className="mb-2 text-sm font- text-gray-900">Payment Method: {seletedPayment.payType}</label>
                {/*<Select
                  className={`${false ? "bg-gray-300" : ""} w-full bg-gray-50 border-gray-300 text-gray-900 text-sm rounded-lg block`}
                  options={GenericColumnData?.salary?.tableColumnData?.find((d: any) => d.key === "payType")?.options || []}
                  onChange={(e) => {
                    setPayType(e);
                  }}
                  value={payType}
                  isClearable={true}
                />*/}
              </div>

              <div className="">
                <label className="block mb-0.5 text-sm font-medium text-gray-900">Payment Ref. No: {seletedPayment.refNo}</label>
                {/*<input
                  type="text"
                  className={`bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5`}
                  placeholder="Payment Ref. No"
                  value={refNo}
                  onChange={(e) => setRefNo(e.target.value)}
                />*/}
              </div>

              <div className="">
                <label className="block mb-0.5 text-sm font-medium text-gray-900">Remark: {seletedPayment.remark}</label>
                {/*<input
                  type="text"
                  className={`bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5`}
                  placeholder="Remark"
                  value={remark}
                  onChange={(e) => setRemark(e.target.value)}
                />*/}
              </div>
              <div className="flex justify-center items-center gap-x-4">
                <button
                  className="mt-4 self-center rounded-md px-4 py-2 text-sm font-medium text-white bg-blue-500 border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700"
                  onClick={() => {
                    /*if (!payDate || !refNo || !payType?.value) {
                      window.alert("Select Valid Value");
                      return;
                    }*/
                    updatePayMutate({
                      url: "/admin/salary/update/" + seletedPayment?.id,
                      data: {
                        status: "PAID",
                        /*payDate: payDate,
                        payType: payType?.value || "",
                        refNo: refNo || "",
                        remark: remark || "",*/
                      },
                    });
                  }}
                >
                  Disburse
                </button>
                <button
                  className="mt-4 self-center rounded-md px-4 py-2 text-sm font-medium text-white bg-green-500 border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700"
                  onClick={() => {
                    setDisburseModalOpen(false);
                  }}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="flex items-center justify-between mt-1 mb-0 font-inter px-4 flex-wrap">
        <div className="flex items-center flex-1">
          <input type="file" accept=".csv" ref={csvFileRef} className="text-sm" />
          <div>
            <Button type="button" size="sm" color="default" className="text-medium ml-2" onPress={handleCsvUpload} isLoading={isUploading}>
              Upload CSV
            </Button>
          </div>
        </div>
        <h1 className="text-lg font-semibold flex-1 text-center">Salary List</h1>

        <div className=" flex-1 flex justify-end">
          <Button
            onPress={() => {
              //setAddModalOpen(true);
              navigator("/master/salary/add");
            }}
            type="button"
            size="sm"
            className="bg-green-700 text-white text-medium"
          >
            Add New
          </Button>
          <Button onPress={exportToExcel} type="button" size="sm" color="primary" className=" ml-4 text-medium">
            Excel Export
          </Button>
        </div>
      </div>

      <div className="px-4 border-[1px] py-2 mx-4 mt-1 rounded-md">
        <div className="flex flex-col items-center">
          <div className="flex items-center gap-x-2 gap-y-2">
            <div className={`items-center gap-2`}>
              <label className="mb-2 text-sm font-semibold text-gray-900">Employee</label>
              <Select
                className={`${false ? "bg-gray-300" : ""} w-48 bg-gray-50 border-gray-300 text-gray-900 text-sm rounded-lg block`}
                options={branchOptions}
                onChange={(e) => {
                  setBranchOtp(e);
                }}
                value={branchOpt}
                isClearable={true}
              />
            </div>
            <div className={`items-center gap-2`}>
              <label className="mb-2 text-sm font-semibold text-gray-900">City</label>
              <Select
                className={`${false ? "bg-gray-300" : ""} w-48 bg-gray-50 border-gray-300 text-gray-900 text-sm rounded-lg block`}
                options={cityOptions}
                onChange={(e) => {
                  setSelectedCity(e);
                }}
                value={selectedCity}
                isClearable={true}
              />
            </div>

            <div className={`items-center gap-2`}>
              <label className="mb-2 text-sm font-semibold text-gray-900">Status</label>
              <Select
                className={`${false ? "bg-gray-300" : ""} w-40 bg-gray-50 border-gray-300 text-gray-900 text-sm rounded-lg block`}
                options={GenericColumnData?.salary?.tableColumnData?.find((d: any) => d.key === "payStatus")?.options || []}
                onChange={(e) => {
                  setSelectedStatus(e);
                }}
                value={selectedStatus}
                isClearable={true}
              />
            </div>

            <AfDateRangePicker setStartDate={setStartDate} setEndDate={setEndDate} label="Start - End Date" />

            <Button type="button" size="sm" color="primary" className="text-medium" onPress={__handleSubmit}>
              Search
            </Button>

            <Button
              onPress={() => {
                loadAttendanceReport("");
              }}
              type="button"
              size="sm"
              color="default"
              className="text-medium"
            >
              Download CSV
            </Button>
          </div>
        </div>
      </div>

      <div className="px-4 py-2 mx-4 my-1 rounded-md text-center">
        {Object.keys(kpsTotal).map((kpsKeys) => {
          return (
            <div
              key={kpsKeys + "-kps"}
              className={`rounded-md p-2 inline-block mr-2 ${kpsKeys == "PENDING" ? "bg-yellow-200" : ""} ${
                kpsKeys == "VERIFIED" ? "bg-purple-200" : ""
              } ${kpsKeys == "PAID" ? "bg-green-300" : ""} ${kpsKeys == "PROCESS" ? "bg-orange-200" : ""}`}
            >
              <p className="font-semibold">
                {kpsKeys || "-"} ({kpsTotal[kpsKeys][0]})
              </p>
              <p className="text-2xl">
                {"₹ " +
                  (Number(kpsTotal[kpsKeys][1]) || 0).toLocaleString("en-IN", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
              </p>
            </div>
          );
        })}
      </div>

      {selectedRows.size > 0 && (
        <div className="px-4 mx-4 my-1 flex items-center gap-2">
          {userDetails.roleName == roles.SUPER_ADMIN && paymentPublicKey && (
            <Button
              onPress={handleBulkPayment}
              color="warning"
              size="sm"
              className="text-white"
            >
              Bulk Payment ({selectedRows.size})
            </Button>
          )}
        </div>
      )}

      <div className="px-4">
        <table className="w-full table- mb-8" style={{ fontSize: "85%" }} id="myTable" ref={tableRef}>
          <thead className="sticky top-0 bg-gray-300">
            <tr className="ignore-excel">
              <th className="border border-slate-200 px-1">
                {selectedRows.size > 0 && (
                  <span className="text-xs">
                    Selected: {selectedRows.size}
                  </span>
                )}
              </th>
              <th className="border border-slate-200 px-1">{tableData?.length}</th>
              <th className="border border-slate-200 px-1"></th>
              <th className="border border-slate-200 px-1"></th>
              <th className="border border-slate-200 px-1"></th>
              <th className="border border-slate-200 px-1"></th>
              <th className="border border-slate-200 px-1">{Number(totals.grand).toFixed(2)}</th>
              <th className="border border-slate-200 px-1">{Number(totals.tds).toFixed(2)}</th>
              <th className="border border-slate-200 px-1">{Number(totals.paid).toFixed(2)}</th>
              <th className="border border-slate-200 px-1"></th>
              <th className="border border-slate-200 px-1"></th>
              <th className="border border-slate-200 px-1"></th>
            </tr>
            <tr>
              <th className="border border-slate-200 px-1">
                <input
                  type="checkbox"
                  checked={tableData?.length > 0 && selectedRows.size === tableData?.length}
                  onChange={(e) => handleSelectAll(e.target.checked)}
                  className="w-4 h-4 cursor-pointer"
                />
              </th>
              <th className="border border-slate-200 px-1">Sr.</th>
              <th className="border border-slate-200 px-1">Id</th>
              <th className="border border-slate-200 px-1">Employee</th>
              <th className="border border-slate-200 px-1 whitespace-nowrap">Salary Month {GET_SORT_ICON("salary_month", "")}</th>
              <th className="border border-slate-200 px-1 whitespace-nowrap">Pay Date {GET_SORT_ICON("payDate", "")}</th>
              <th className="border border-slate-200 px-1">Net Salary</th>
              <th className="border border-slate-200 px-1">tds</th>
              <th className="border border-slate-200 px-1">Paid Amt</th>
              <th className="border border-slate-200 px-1 whitespace-nowrap">Status {GET_SORT_ICON("Status", "asc")}</th>
              <th className="border border-slate-200 px-1">Remark</th>
              <th className="border border-slate-200 px-1">-</th>
            </tr>
          </thead>
          <tbody>
            {tableData &&
              tableData.map((r, i) => {
                return (
                  <tr
                    key={"r" + r.id}
                    className={`${
                      r.payStatus == "PAID"
                        ? "bg-green-300"
                        : r.payStatus == "REJECTED"
                        ? "bg-red-300"
                        : r.payStatus == "PENDING"
                        ? "bg-yellow-200"
                        : r.payStatus == "VERIFIED"
                        ? "bg-purple-200"
                        : r.payStatus == "PROCESS"
                        ? "bg-orange-200"
                        : ""
                    }`}
                  >
                    <td className="border border-slate-200 px-2">
                      <input
                        type="checkbox"
                        checked={selectedRows.has(r.id)}
                        onChange={(e) => handleRowSelect(r.id, e.target.checked)}
                        className="w-4 h-4 cursor-pointer"
                      />
                    </td>
                    <td className="border border-slate-200 px-2">{i + 1}</td>
                    <td className="border border-slate-200 px-2">{r.id}</td>
                    <td className="border border-slate-200 px-2">{r._employee?.name}</td>
                    <td className="border border-slate-200 px-2">
                      {r.salary_month && r.salary_month != "Invalid Date" ? moment(r.salary_month).format("MM - MMMM") : "-"}
                    </td>
                    <td className="border border-slate-200 px-2">
                      {r.pay_date && r.pay_date != "Invalid Date" ? moment(r.pay_date, "DD-MM-YYYY HH:mm:ss").format("DD/MM/YYYY") : "-"}
                    </td>
                    <td className="border border-slate-200 px-2 text-right">{r.net_salary}</td>
                    <td className="border border-slate-200 px-2 text-right">{r.tds}</td>
                    <td className="border border-slate-200 px-2 text-right">{(r.net_salary - r.tds).toFixed(2)}</td>
                    <td className="border border-slate-200 px-2">{r.payStatus}</td>
                    <td className="border border-slate-200 px-2">{r.remark}</td>
                    <td className="border border-slate-200 px-2">
                      <button
                        onClick={() => {
                          //navigator(`/master/salary/list/${r.id}`);
                          window.open(`/master/salary/list/${r.id}`, "_blank");
                        }}
                        className="text-blue-500"
                      >
                        View
                      </button>
                      <br />
                      <button
                        onClick={() => {
                          let confirm_ = window.confirm("Are you sure");
                          if (confirm_) {
                            deleteSalary(r.id);
                          }
                          //navigator(`/master/salary/list/${r.id}`);
                        }}
                        className="text-red-500"
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default SalaryList;
